import { render, staticRenderFns } from "./BottomDrawer.vue?vue&type=template&id=0fea815a&scoped=true"
import script from "./BottomDrawer.vue?vue&type=script&lang=ts"
export * from "./BottomDrawer.vue?vue&type=script&lang=ts"
import style0 from "./BottomDrawer.vue?vue&type=style&index=0&id=0fea815a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fea815a",
  null
  
)

export default component.exports